export default "__VITE_ASSET__aecd3791__"